<div class="well well-sm text-muted small custom-id-wrapper">
    @if (!isEditing()) {
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex">
                <span [tooltip]="'id_hint_tooltip' | translate" class="sp-icon icon-info-bold color-light"> </span>
                ID:
                <span
                    class="custom-id-content"
                    [tooltip]="copiedTooltip"
                    triggers="click:mouseleave"
                    [cdkCopyToClipboard]="displayId()"
                >
                    {{ displayId() }}
                    <ng-template #copiedTooltip>
                        {{ "copied_tooltip" | translate }}
                    </ng-template>
                </span>
            </div>
            <button type="button" class="btn btn-link pull-right" [disabled]="disabled()" (click)="editId()">
                <span class="sp-icon icon-ap-edit"> </span>
            </button>
        </div>
    } @else {
        <div class="custom-id-control">
            <input
                class="form-control input-sm"
                type="text"
                [value]="editedId()"
                [placeholder]="'control_set_id' | translate"
                (input)="setEditedId($event)"
            />
            <button
                type="button"
                class="btn btn-success btn-xs"
                [class.disabled]="isEditedIdEmpty()"
                (click)="saveId()"
            >
                <img src="./assets/img/websites/lpc-btn-ok-icon.svg" alt="lpc-btn-ok-icon" />
            </button>
            <span class="close-custom-id-edit text-muted" (click)="cancelChangeId()">×</span>
        </div>
    }
</div>
